export * from './Auth'
export * from './Material'
export * from './Hero'



// WEBPACK FOOTER //
// ./src/graphql/queries/index.js